/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Selected_TitleInputs */



/**
* | output |
* | --- |
* | "Selected Style Guide" |
*
* @param {Tags_Selected_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_selected_title = /** @type {((inputs?: Tags_Selected_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Selected_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide de style selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählter Styleguide")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida di stile selezionata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Руководство по выбору стиля")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía de estilo seleccionada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("精选风格指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択されたスタイルガイド")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित शैली मार्गदर्शिका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guia de Estilo Selecionado")
	return /** @type {LocalizedString} */ ("Selected Style Guide")
});